import { ApiFunctionNoParamType, ApiFunctionType, httpGetCancellable, httpPostCancellable } from 'src/utils/http';
import {
  FeatureToggleScopeEnum,
  FeatureFlagItemType,
  FeatureFlagRawItemType,
  FeatureFlagSaveItemType,
  normalizeFlagItem,
} from 'src/models/featureFlags';

export type { FeatureToggleScopeEnum, FeatureFlagItemType, FeatureFlagSaveItemType };

const path = '/featuretoggle';

const apiGetFeatureFlagListRaw: ApiFunctionNoParamType<FeatureFlagRawItemType[]> = httpGetCancellable(
  `${path}/toggles`
);

const apiGetFeatureFlagListWithSearchRaw: ApiFunctionType<
  { scope: FeatureToggleScopeEnum; targetID: number },
  FeatureFlagRawItemType[]
> = httpGetCancellable(`${path}/togglesbyscopefortarget`);

/** get list */
export const apiGetFeatureFlagList = (): Promise<FeatureFlagItemType[]> =>
  apiGetFeatureFlagListRaw().then((res) => res.map(normalizeFlagItem));

/** get enabled toggles by scope and entity id */
export const apiGetFeatureFlagListWithSearch = (data: {
  scope: FeatureToggleScopeEnum;
  targetID: number;
}): Promise<FeatureFlagItemType[]> =>
  apiGetFeatureFlagListWithSearchRaw(data).then((res) => res.map(normalizeFlagItem));

/** save list */
export const apiSaveFeatureFlagList: ApiFunctionType<
  { Toggles: FeatureFlagSaveItemType[]; Scope: FeatureToggleScopeEnum; targetID?: number },
  void
> = httpPostCancellable(`${path}/save`);
